import { render, staticRenderFns } from "./LoginDetail.vue?vue&type=template&id=1be5827f&"
import script from "./LoginDetail.vue?vue&type=script&lang=js&"
export * from "./LoginDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports